import {
  firstName,
  lastName,
  emailAddress,
  primaryLoanPurpose,
  howDidYouHearAboutThisProduct,
  doYouHaveAFundingCode,
  homeBasedBusiness,
  homeAddress1,
  homeAddress2,
  city,
  state,
  zip,
  personalPhoneNumber,
  personalPhoneNumberType,
  businessAddress1,
  businessAddress2,
  businessCity,
  businessState,
  businessZip,
  businessPhoneNumber,
  businessWebAddress,
  businessEntityType,
  legalBusinessName,
  doingBusinessAsRadio,
  doingBusinessAs,
  stateOfIncorporation,
  totalAnnualBusinessRevenue,
  businessStartDate,
  numberOfFullTimeEmployees,
  businessIndustry,
  businessSubIndustry,
  dateOfBirth,
  socialSecurityNumber,
  federalTaxId,
  percentageOfOwnership,
  isControllingManager,
  agreedToTermsAndConditions,
} from './applicationFields'

const applicationPage1Fields = [
  legalBusinessName,
  [firstName, lastName],
  emailAddress,
  personalPhoneNumber,
  personalPhoneNumberType,
  primaryLoanPurpose,
  howDidYouHearAboutThisProduct,
  doYouHaveAFundingCode,
  agreedToTermsAndConditions
]

const applicationPage1FieldsRenewal = [
  legalBusinessName,
  [firstName, lastName],
  emailAddress,
  personalPhoneNumber,
  personalPhoneNumberType,
  primaryLoanPurpose,
  doYouHaveAFundingCode,
  agreedToTermsAndConditions
]

const applicationPage2Fields = [
  homeAddress1,
  homeAddress2,
  city,
  [state, zip],
]

const applicationPage3Fields = [
  businessAddress1,
  businessAddress2,
  businessCity,
  [businessState, businessZip],
  businessPhoneNumber,
  businessWebAddress,
]

const applicationPage3FieldsApp = [homeBasedBusiness, ...applicationPage3Fields]

const applicationPage4Fields = [
  doingBusinessAsRadio,
  doingBusinessAs,
  businessEntityType,
  stateOfIncorporation,
  totalAnnualBusinessRevenue,
  businessStartDate,
  numberOfFullTimeEmployees,
  businessIndustry,
  businessSubIndustry,
]

const applicationPage4FieldsRenewal = [
  doingBusinessAs,
  businessEntityType,
  stateOfIncorporation,
  totalAnnualBusinessRevenue,
  businessStartDate,
  numberOfFullTimeEmployees,
  businessIndustry,
  businessSubIndustry,
]

const applicationPage5Fields = [
  dateOfBirth,
  socialSecurityNumber,
  federalTaxId,
  percentageOfOwnership,
  isControllingManager,
]

const getApplicationFields = (applicationType: string) => {
  let newApplicationPage1Fields = []
  let newApplicationPage3Fields = []
  let newApplicationPage4Fields = []

  if (
    applicationType === 'app-renewal' ||
    applicationType === 'paypal-renewal'
  ) {
    newApplicationPage1Fields = [
      personalPhoneNumber,
      personalPhoneNumberType,
      primaryLoanPurpose,
      doYouHaveAFundingCode,
      agreedToTermsAndConditions
    ]
    newApplicationPage3Fields = [businessPhoneNumber, businessWebAddress]
    newApplicationPage4Fields = [
      totalAnnualBusinessRevenue,
      numberOfFullTimeEmployees,
    ]
  } else if (applicationType === 'paypal') {
    newApplicationPage1Fields = [
      legalBusinessName,
      [firstName, lastName],
      personalPhoneNumber,
      personalPhoneNumberType,
      primaryLoanPurpose,
      howDidYouHearAboutThisProduct,
      doYouHaveAFundingCode,
      agreedToTermsAndConditions,
    ]
    newApplicationPage3Fields = [businessPhoneNumber, businessWebAddress]
    newApplicationPage4Fields = applicationPage4Fields
  } else if (applicationType === 'app') {
    newApplicationPage1Fields = applicationPage1Fields
    newApplicationPage3Fields = [businessPhoneNumber, businessWebAddress]
    newApplicationPage4Fields = applicationPage4Fields
  }
  return {
    newApplicationPage1Fields,
    newApplicationPage3Fields,
    newApplicationPage4Fields,
  }
}

export {
  applicationPage1Fields,
  applicationPage1FieldsRenewal,
  applicationPage2Fields,
  applicationPage3Fields,
  applicationPage3FieldsApp,
  applicationPage4Fields,
  applicationPage4FieldsRenewal,
  applicationPage5Fields,
  getApplicationFields,
}
